import NetworkInfo from '../schema/NetworkInfo';

/**
 * Method that gives the current user network info.
 */
export default function (): NetworkInfo {
    const nav = <any>navigator;
    const connection = nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    return connection
        ? {
              type: connection?.type,
              effectiveType: connection?.effectiveType,
              downlink: connection?.downlink,
              rtt: connection?.rtt,
              saveData: connection?.saveData,
          }
        : null;
}
